import { createFileRoute } from '@tanstack/react-router';
import { fetchIncomingTransactionTracing } from '@/api/transactions';
import { FiberTracingTab } from '@/app/(client)/transactions/-components/FiberTracingTab';
import {
  incomingTracingKeys,
  useIncomingTransactionTracing,
} from '@/app/(client)/transactions/-hooks/useIncomingTransactionTracing';
import { Skeleton } from '@/components/ui/skeleton';
import { queryClient } from '@/lib/utils/queryClient';

export const Route = createFileRoute(
  '/(client)/transactions/(pages)/(detail)/incoming/$txId/tracing',
)({
  loader: ({ params }) =>
    queryClient
      .ensureQueryData({
        queryKey: incomingTracingKeys.detail(params.txId),
        queryFn: () => fetchIncomingTransactionTracing(params.txId),
      })
      .catch(() => null),
  component: IncomingTransactionTracingTab,
});

function IncomingTransactionTracingTab() {
  const { txId } = Route.useParams();
  const { data: tracing, isLoading } = useIncomingTransactionTracing(txId);

  if (isLoading) {
    return (
      <div className='flex flex-col gap-4'>
        <Skeleton className='h-8 w-40' />
        <Skeleton className='w-full rounded-xl h-[calc(100vh-340px)] min-h-100' />
      </div>
    );
  }

  if (!tracing) return null;

  return <FiberTracingTab tracing={tracing} />;
}
